import * as React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { CalendarCell } from 'wix-ui-tpa';
import { st, classes } from './Cell.st.css';
var Cell = function (_a) {
    var timezone = _a.timezone, timeType = _a.timeType, isWeekEnd = _a.isWeekEnd, isStretchable = _a.isStretchable, timeToDisplay = _a.timeToDisplay, current = _a.current, alignment = _a.alignment, events = _a.events, render = _a.render, time = _a.time, popperPlacement = _a.popperPlacement, popperStyle = _a.popperStyle, _b = _a.cellHeight, cellHeight = _b === void 0 ? 0 : _b, _c = _a.isShrinking, isShrinking = _c === void 0 ? false : _c, _d = _a.isTodayClicked, isTodayClicked = _d === void 0 ? false : _d, _e = _a.isBorderShown, isBorderShown = _e === void 0 ? false : _e, _f = _a.isMobile, isMobile = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? '' : _g, _h = _a.selected, selected = _h === void 0 ? false : _h, _j = _a.handleDateResize, handleDateResize = _j === void 0 ? function (width, height) { } : _j, _k = _a.dateHeight, dateHeight = _k === void 0 ? 0 : _k, _l = _a.handleEventTitleResize, handleEventTitleResize = _l === void 0 ? function (width, height) { } : _l, _m = _a.eventTitleHeight, eventTitleHeight = _m === void 0 ? 0 : _m, _o = _a.eventTimeHeight, eventTimeHeight = _o === void 0 ? 0 : _o, _p = _a.handleEventTimeResize, handleEventTimeResize = _p === void 0 ? function (width, height) { } : _p, localeToggle = _a.localeToggle;
    //@ts-ignore
    var dateRef = React.useRef();
    React.useEffect(function () {
        _dateResizeHandler();
    }, []);
    var _dateResizeHandler = function (width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        var newDateHeight = dateRef.current.getBoundingClientRect().height;
        var padding = 8;
        handleDateResize(0, newDateHeight + padding);
    };
    var eventsToShow = events.length
        ? render({
            time: time,
            events: events,
            popperPlacement: popperPlacement,
            popperStyle: popperStyle,
            cellHeight: cellHeight,
            isShrinking: isShrinking,
            dateHeight: dateHeight,
            eventTitleHeight: eventTitleHeight,
            eventTimeHeight: eventTimeHeight,
            handleEventTitleResize: handleEventTitleResize,
            handleEventTimeResize: handleEventTimeResize,
            timezone: timezone,
            localeToggle: localeToggle,
        })
        : null;
    var date = (React.createElement("div", { "aria-label": "".concat(timeToDisplay, "."), ref: dateRef },
        timeToDisplay,
        React.createElement(ReactResizeDetector, { onResize: _dateResizeHandler })));
    return (React.createElement(CalendarCell, { className: st(classes.root, {
            isTodayClicked: isTodayClicked,
            isMobile: isMobile,
            isBorderShown: isBorderShown,
            timeType: timeType,
            isWeekEnd: isWeekEnd,
            isStretchable: isStretchable,
            selected: selected,
        }, className), 
        //@ts-ignore
        title: date, timeType: timeType, current: current, alignment: alignment, stretchable: isStretchable }, eventsToShow));
};
export default Cell;
//# sourceMappingURL=Cell.js.map